import { render, staticRenderFns } from "./EchartsPolarChart.vue?vue&type=template&id=5b56a3c2&"
import script from "./EchartsPolarChart.vue?vue&type=script&lang=js&"
export * from "./EchartsPolarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports